import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core';
import RenderMobile from '../components/common/breakpoints/RenderMobile';
import RenderDesktop from '../components/common/breakpoints/RenderDesktop';
import { FULL_BLACK_COLOR, NAVBAR_COLOR, WHITE_COLOR } from '../const/color-const';

export const CustomFreshDeskIcon = (props) => {
  const theme = useTheme();
  const isLightMode = theme.palette.type === 'light';
  
  const renderSvgIcon = (fillColor) => (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="12 30 40 1">
        <path
          d="M31.9 14.255c-8.093 0-14.654 6.56-14.654 14.654v9.964c.058 2.667 2.206 4.815 4.873 4.873h4.145V32.3h-5.6v-3.2c.34-6.026 5.327-10.74 11.364-10.74S43.04 23.065 43.38 29.1v3.2H37.7v11.454h3.745v.182c-.04 2.474-2.035 4.47-4.5 4.5h-4.473c-.364 0-.764.182-.764.545a.8.8 0 0 0 .764.764h4.5c3.205-.02 5.798-2.613 5.818-5.818v-.364a4.8 4.8 0 0 0 3.745-4.727V29.1c.182-8.254-6.364-14.836-14.654-14.836z"
          fill={fillColor} />
      </svg>
    </SvgIcon>
  );
  
  return (
    <>
      <RenderMobile>
        {renderSvgIcon(isLightMode ? FULL_BLACK_COLOR : WHITE_COLOR)}
      </RenderMobile>
      
      <RenderDesktop>
        {renderSvgIcon(NAVBAR_COLOR)}
      </RenderDesktop>
    </>
  );
};

export default CustomFreshDeskIcon;